import React from "react"
import { Router } from "react-router-dom"
import { history } from "my-history"

import Routes from "./routes"
import Shared from "Shared"

function App() {
  return (
    <Router history={history}>
      <Shared>
        <Routes />
      </Shared>
    </Router>
  )
}

export default App
